import { EDealTypes } from '../types/dealTypes';

export const DEAL_TYPE_BY_CATEGORIES: Record<string, EDealTypes | undefined> = {
  flatSale: EDealTypes.FlatSale,
  roomSale: EDealTypes.FlatSale,
  newBuildingFlatSale: EDealTypes.FlatSale,
  flatShareSale: EDealTypes.FlatSale,
  houseSale: EDealTypes.SuburbanSale,
  cottageSale: EDealTypes.SuburbanSale,
  townhouseSale: EDealTypes.SuburbanSale,
  houseShareSale: EDealTypes.SuburbanSale,
  landSale: EDealTypes.SuburbanSale,
  flatRent: EDealTypes.FlatRent,
  roomRent: EDealTypes.FlatRent,
  bedRent: EDealTypes.FlatRent,
  houseRent: EDealTypes.SuburbanRent,
  cottageRent: EDealTypes.SuburbanRent,
  townhouseRent: EDealTypes.SuburbanRent,
  houseShareRent: EDealTypes.SuburbanRent,
  dailyFlatRent: EDealTypes.DailyRent,
  dailyRoomRent: EDealTypes.DailyRent,
  dailyBedRent: EDealTypes.DailyRent,
  dailyHouseRent: EDealTypes.DailyRent,
  officeSale: EDealTypes.CommercialSale,
  warehouseSale: EDealTypes.CommercialSale,
  shoppingAreaSale: EDealTypes.CommercialSale,
  industrySale: EDealTypes.CommercialSale,
  buildingSale: EDealTypes.CommercialSale,
  freeAppointmentObjectSale: EDealTypes.CommercialSale,
  businessSale: EDealTypes.CommercialSale,
  commercialLandSale: EDealTypes.CommercialSale,
  garageSale: EDealTypes.CommercialSale,
  publicCateringSale: EDealTypes.CommercialSale,
  carServiceSale: EDealTypes.CommercialSale,
  domesticServicesSale: EDealTypes.CommercialSale,
  officeRent: EDealTypes.CommercialRent,
  warehouseRent: EDealTypes.CommercialRent,
  shoppingAreaRent: EDealTypes.CommercialRent,
  industryRent: EDealTypes.CommercialRent,
  buildingRent: EDealTypes.CommercialRent,
  freeAppointmentObjectRent: EDealTypes.CommercialRent,
  businessRent: EDealTypes.CommercialRent,
  commercialLandRent: EDealTypes.CommercialRent,
  garageRent: EDealTypes.CommercialRent,
  publicCateringRent: EDealTypes.CommercialRent,
  carServiceRent: EDealTypes.CommercialRent,
  domesticServicesRent: EDealTypes.CommercialRent,
};
